import './AnnualReport.css';

import useMeta from '../../../../hooks/useMeta';

import { Link } from "react-router-dom";

import Footer from "../../../../CommonComponent/Footer/footer";
import Navbar from "../../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../../CommonComponent/Notification/NotificationBar";

const Annual_Report = () => {

    const data = [
        { title: 'AR/AGM 2017-18', url: '/annual-report/ar-agm-2017-18' },
        { title: 'AR/AGM 2018-19', url: '/annual-report/ar-agm-2018-19' },
        { title: 'AR/AGM 2019-20', url: '/annual-report/ar-agm-2019-20' },
        { title: 'AR/AGM 2020-21', url: '/annual-report/ar-agm-2020-21' },
        { title: 'AR/AGM 2021-22', url: '/annual-report/ar-agm-2021-22' },
        { title: 'AR/AGM 2022-23', url: '/annual-report/ar-agm-2022-23' },
        { title: 'AR/AGM 2023-24', url: '/annual-report/ar-agm-2023-24' },
        { title: 'AR/AGM 2024-25', url: '/annual-report/ar-agm-2024-25' },
        { title: 'AR/AGM 2025-26', url: '/annual-report/ar-agm-2025-26' }
    ]

    function CheckValue(index) {
        return (index % 2 !== 0) ? true : false
    }

    useMeta({
        title: 'Annual Report / AGM | Marvel Blinds',
        description: "AR/AGM 2017-18 AR/AGM 2018-19 AR/AGM 2019-20 AR/AGM 2020-21 AR/AGM 2021-22 AR/AGM 2022-23 AR/AGM 2023-24 AR/AGM 2024-25 AR/AGM 2025-26",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/annual-report-agm`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Annual Report / AGM',
            description:
                "AR/AGM 2017-18 AR/AGM 2018-19 AR/AGM 2019-20 AR/AGM 2020-21 AR/AGM 2021-22 AR/AGM 2022-23 AR/AGM 2023-24 AR/AGM 2024-25 AR/AGM 2025-26",
            url: `${process.env.REACT_APP_WEBSITE_URL}/annual-report-agm`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="AR_pg_container">
                <h1 className="AR_pg_title">ANNUAL REPORT / AGM</h1>
                <table className="AR_pg_table">
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td className={CheckValue(index) === true ? 'Border-none' : 'even-row'}>
                                    <Link to={item.url || "#"}>
                                        {item.title}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}


export default Annual_Report;